import React from 'react';
import { Theme } from 'vindi-ds-components';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';

export default function App() {
  return (
    <Theme>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Theme>
  );
}
